import { FC } from 'react';
import { useIntl } from 'react-intl';
import { labelMessages } from './messages';
import {
  StyledVoidDocumentIdContent,
  StyledVoidMessageContent,
  StyledVoidPaymentContent,
  StyledVoidPaymentDialog,
  StyledVoidPaymentLabelAndValue
} from './styled';
import { VoidPaymentDialogContentType } from './types';

export const VoidPaymentDialogContent: FC<VoidPaymentDialogContentType> = ({
  documentId,
  vendorId,
  vendorName,
  paymentDate,
  paymentAmount
}) => {
  const intl = useIntl();

  return (
    <StyledVoidPaymentDialog>
      <StyledVoidMessageContent>
        {intl.formatMessage(labelMessages.paymentMessage)}
      </StyledVoidMessageContent>

      <StyledVoidDocumentIdContent>
        {intl.formatMessage(labelMessages.documentIdInDialogLabel)}{' '}
        {`#${documentId}`}
      </StyledVoidDocumentIdContent>

      <StyledVoidPaymentContent>
        <StyledVoidPaymentLabelAndValue>
          {vendorName} {`#${vendorId}`}
        </StyledVoidPaymentLabelAndValue>
        <StyledVoidPaymentLabelAndValue>
          {intl.formatMessage(labelMessages.paymentDateInDialogLabel)}
          {`: ${paymentDate}`}
        </StyledVoidPaymentLabelAndValue>
        <StyledVoidPaymentLabelAndValue>
          {intl.formatMessage(labelMessages.amountInDialogLabel)}
          {`: $${paymentAmount.toFixed(2)}`}
        </StyledVoidPaymentLabelAndValue>
      </StyledVoidPaymentContent>
    </StyledVoidPaymentDialog>
  );
};
